import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { isLoggingSettingUsageEnabled, trackSettingsAndExperiment } from "@faire/web--source/common/serialized-setting-tracker/SerializedSettingTracker";
import isEqual from "lodash/isEqual";
/**
 * Getter logic shared between the hook implementation and the legacy implementation of setting retrieval.
 */ export function sharedGetSetting(settingOrKey, serializedValues, overrideSettingValue, defaultValue) {
    var key;
    var serializedSettingValue;
    if (typeof settingOrKey === "string") {
        key = settingOrKey;
        serializedSettingValue = serializedValues === null || serializedValues === void 0 ? void 0 : serializedValues[settingOrKey];
    } else {
        key = settingOrKey.name;
        serializedSettingValue = serializedValues === null || serializedValues === void 0 ? void 0 : serializedValues[settingOrKey.name];
    }
    var _ref;
    var surfacedSettingValue = (_ref = overrideSettingValue !== null && overrideSettingValue !== void 0 ? overrideSettingValue : serializedSettingValue) !== null && _ref !== void 0 ? _ref : defaultValue;
    if (isLoggingSettingUsageEnabled()) {
        trackSettingsAndExperiment([
            key
        ], {
            settingValue: surfacedSettingValue
        });
    }
    if (getGlobalProperty("envName") !== "production" && getGlobalProperty("needsHydration", false) && overrideSettingValue !== undefined && !isEqual(overrideSettingValue, serializedSettingValue !== null && serializedSettingValue !== void 0 ? serializedSettingValue : defaultValue)) {
        // We provide a mechanism to override settings in development,
        // but we want to make sure that the same settings are used
        // for the server render as on the client, to prevent mismatches
        // (React error #418 and #425).
        throw new Error("Expected ".concat(key, " to be ").concat(JSON.stringify(serializedSettingValue !== null && serializedSettingValue !== void 0 ? serializedSettingValue : defaultValue), " (server value) but it was overriden to be ").concat(JSON.stringify(overrideSettingValue), ". This is because something in localStorage.PublicSettingsOverrides was not ") + "passed to X-IF-SETTINGS. If you have disabled the extention, consider clearing " + "localStroage.");
    }
    return surfacedSettingValue;
}
